<div class="schedule-rules-scroll-container" (scroll)="onScroll($event)">
  @for (scheduleRule of visibleRules(); track scheduleRule.id) {
    <app-schedule-rule-card
      class="schedule-rule-card"
      [class.hidden]="!isRuleVisible(scheduleRule.id)"
      [scheduleRule]="scheduleRule"
      [shopName]="shopNameMap().get(scheduleRule.shop_id) || ''"
      [userName]="userNameMap().get(scheduleRule.user_in_charge || '') || ''"
      (toggleActive)="onToggleActive(scheduleRule.id, $event)"
      (updateWeekdays)="onUpdateWeekdays(scheduleRule.id, $event)"
      (requestUpdateFromAdmin)="onRequestUpdateFromAdmin(scheduleRule.shop_id)"
      (updateSchedulingRequirements)="onUpdateSchedulingRequirements(scheduleRule.shop_id, $event)"
    ></app-schedule-rule-card>
  }

  @if (hasMoreItems()) {
    <div class="loading-indicator">
      <p>Scroll para carregar mais...</p>
    </div>
  }
</div>
